import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const JSSettingsView = React.lazy(() => import("./JSSettings.view"));

const JSSettingsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <JSSettingsView />
  </React.Suspense>
);
export default () => <JSSettingsLoadable />;
